import React, { useEffect } from 'react'
import { Flex, Box } from '@theme-ui/components'
import TextContent from '../components/General/TextContent'
import Instagram from '../components/General/Icons/Instagram'
export default function ScriptWidget({
  // businessData,
  // configData,
  // pageTitle,
  locationIndex,
  variantName,
  options
  // isMultiLocationSite,
}) {
  const { titles, subtitles, texts, scriptWidget, scriptId, instagramWidgetSrc, containerStyles } = options

  // const { city } = businessData

  const styles = containerStyles ? JSON.parse(containerStyles) : {}
  const variant = variantName ? variantName : 'instagramWidget'

  useEffect(() => {
    if (scriptWidget && scriptWidget[locationIndex]) {
      const script = document.createElement('script')

      if (scriptId && scriptId[locationIndex]) {
        script.id = scriptId[locationIndex]
      }
      script.type = 'text/javascript'
      script.src = scriptWidget[locationIndex]
      script.async = true
      document.getElementById('scriptWidget').appendChild(script)
    }
    return () => {}
  }, [])

  return (
    <Flex
      variant={`${variant}.container`}
      className="scriptWidget"
      sx={{
        ...styles
      }}
    >
      <div id={'scriptWidget'}></div>
      <Flex variant={`${variant}.logoAndTextContainer`} className="logoAndTextContainer">
        <Instagram />
        <TextContent
          variantName={variantName}
          title={titles ? titles[locationIndex] : null}
          subtitle={subtitles ? subtitles[locationIndex] : null}
          text={texts ? texts[locationIndex] : null}
        />
      </Flex>
      <Box variant={`${variant}.iFrameContainer`} className="iFrameContainer">
        {instagramWidgetSrc ? (
          <iframe
            title={'instagramWidget'}
            src={instagramWidgetSrc}
            scrolling="no"
            allowtransparency="true"
            className="lightwidget-widget"
            style={{ width: '100%', border: '0px', overflow: 'hidden' }}
          />
        ) : (
          ''
        )}
      </Box>
    </Flex>
  )
}
